import React from 'react';

import InputField from './InputField';
import { validatePassword } from '../validations/validations';

type PropsType = {
    name: string,
    label: string,
    value: string,
    required?: boolean,
    helperText?: string,
    sx?: {[key: string]: string | number },
    variant?: 'filled' | 'outlined' | 'standard',
    onChange: (a: any) => void,
    submitOnEnter?: boolean,
    autoComplete?: string
};

export default function TextField(props: PropsType) {
    const { value } = props;

    const validations = [validatePassword({ value })];

    return (
        <InputField
            {...props}
            type="password"
            validations={validations}
        />
    );
}
